export type FeatureFlagKey =
  | 'aiAssist'
  | 'aiAssistActivityBranching'
  | 'disableCompletionCriteriaGuard'
  | 'importExport'
  | 'isLeagueUser'
  | 'masonryContent'
  | 'syncEnvironment';

export type FeatureFlagDefinition = {
  key: FeatureFlagKey;
  label: string;
  description?: string;
  /**
   * Flags are intentionally hidden from the Feature Flags Settings UI page as they are not user-facing.
   */
  isHiddenFromUi?: boolean;
  /** User email domains for which this flag is automatically enabled (e.g., ['league.com']) */
  enabledForUserEmailDomains?: string[];
  /** Tenant IDs for which this flag is automatically enabled */
  enabledForTenants?: string[];
};

export const featureFlags: FeatureFlagDefinition[] = [
  {
    key: 'aiAssist',
    label: 'AI assist (cohorts & campaigns)',
    description:
      'Enable AI-assisted generation for JSON logic rules in cohort and campaign flows.',
    enabledForUserEmailDomains: ['league.com'],
  },
  {
    key: 'aiAssistActivityBranching',
    label: 'AI assist (activity branching)',
    description:
      'Enable AI-assisted generation for activity page branching logic.',
    enabledForUserEmailDomains: ['league.com'],
  },
  {
    key: 'disableCompletionCriteriaGuard',
    label: 'Emergency: disable completion criteria publish guard',
    description:
      'Emergency kill switch for the config-activity completion criteria guard. It blocks publish, copy to environment, and import when a rule template is selected but completionCriteria is empty or unresolved, or when completionData.eventId is task_completed with no criteria. Turn on only to unblock authors if it misfires — it protects against silent completionCriteria data loss.',
  },
  {
    key: 'importExport',
    label: 'Import / export',
    description: 'Enable import and export tools in the UI.',
  },
  {
    key: 'isLeagueUser',
    label: 'Is league user',
    description:
      'Internal flag automatically enabled for League users; hidden from the Feature Flags UI.',
    enabledForUserEmailDomains: ['league.com'],
    isHiddenFromUi: true,
  },
  {
    key: 'masonryContent',
    label: 'Masonry Content',
    description:
      'Author Contentful masonryGenericContent entries directly from League Config.',
    enabledForUserEmailDomains: ['league.com'],
  },
  {
    key: 'syncEnvironment',
    label: 'Sync environment',
    description: 'Enable syncing entities across environments.',
    enabledForUserEmailDomains: ['league.com'],
    enabledForTenants: [
      'medibank-mymedibank',
      'medibank-pp',
      'medibank-valencia',
    ],
  },
];
